tariffs = {
	init() {
		const
			mobileRes = getBreakpoint('mobile'),
			tabletRes = getBreakpoint('tablet');

		new Swiper('.js-calculator-slider', {
			spaceBetween: 20,
			autoHeight: false,

			navigation: {
				prevEl: '.js-calculator-prev',
				nextEl: '.js-calculator-next',
			},

			breakpoints: {
				0: {
					slidesPerView: 1.75,
				},

                [tabletRes]: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
			}
		});

		new Swiper('.js-reviews-slider', {
			spaceBetween: 20,
			autoHeight: false,

			navigation: {
				prevEl: '.js-reviews-prev',
				nextEl: '.js-reviews-next',
			},

            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                },

                [tabletRes]: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            }
		});

        this.initStickyButton();
	},

    /**
     * Плавающая кнопка при уходе hero за экран
     */
    initStickyButton() {
        const $hero = $('.js-sticky');

        if (!$hero.length)
            return;

        const
            $button = $hero.find('.button').first();

        if (!$button.length)
            return;

        // Панель с клоном кнопки
        const
            $bar = $('<div class="tariffs-sticky-bar"></div>');

        $bar.append($button.clone());
        $('.tariffs').append($bar);

        // Появляется когда hero уходит за экран
        const observer = new IntersectionObserver(
            ([entry]) => $bar.toggleClass(
                'tariffs-sticky-bar--visible',
                !entry.isIntersecting
            ),

            {threshold: 0},
        );

        observer.observe($hero[0]);
    },
}



$(document).ready(function() {
	tariffs.init();
});